export default {
    title: 'E-Mails',

    id: 'ID',
    recipient: 'Empfänger',
    mailTemplate: 'E-Mailvorlage',
    process: 'Vorgang',
    statisticProcess: 'Statistikmeldung',
    status: 'Status',
    updated_at: 'Zuletzt aktualisiert',
}